'use client'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { getNavigationTranslationNav } from '@trainkr/navigation'

import { LanguagesSupported } from '@/i18n/language'

function navigationNavForWebLang(lang: string) {
  return lang === 'zh-Hans'
    ? getNavigationTranslationNav('zh-Hans')
    : getNavigationTranslationNav('en-US')
}

const loadLangResources = (lang: string) => ({
  translation: {
    common: require(`./${lang}/common`).default,
    routerConfig: require(`./${lang}/config`).default,
    layout: require(`./${lang}/layout`).default,
    login: require(`./${lang}/login`).default,
    register: require(`./${lang}/register`).default,
    market: require(`./${lang}/market`).default,
    app: require(`./${lang}/app`).default,
    appOverview: require(`./${lang}/app-overview`).default,
    appDebug: require(`./${lang}/app-debug`).default,
    appApi: require(`./${lang}/app-api`).default,
    appLog: require(`./${lang}/app-log`).default,
    share: require(`./${lang}/share-app`).default,
    dataset: require(`./${lang}/dataset`).default,
    datasetDocuments: require(`./${lang}/dataset-documents`).default,
    billing: require(`./${lang}/billing`).default,
    custom: require(`./${lang}/custom`).default,
    mlops: require(`./${lang}/mlops`).default,
    deployment:
      lang === 'zh-Hans'
        ? require(`./lang/deployment.zh`).default
        : require(`./lang/deployment.en`).default,
    train:
      lang === 'zh-Hans'
        ? require(`./lang/train.zh`).default
        : require(`./lang/train.en`).default,
    ecs:
      lang === 'zh-Hans'
        ? require(`./lang/ecs.zh`).default
        : require(`./lang/ecs.en`).default,
    table:
      lang === 'zh-Hans'
        ? require(`./lang/table.zh`).default
        : require(`./lang/table.en`).default,
    fee:
      lang === 'zh-Hans'
        ? require(`./lang/fee.zh`).default
        : require(`./lang/fee.en`).default,
    audit_log:
      lang === 'zh-Hans'
        ? require(`./lang/audit_log.zh`).default
        : require(`./lang/audit_log.en`).default,
    resource_quotas:
      lang === 'zh-Hans'
        ? require(`./lang/resource_quotas.zh`).default
        : require(`./lang/resource_quotas.en`).default,
    resource_dedicated:
      lang === 'zh-Hans'
        ? require(`./lang/resource_dedicated.zh`).default
        : require(`./lang/resource_dedicated.en`).default,
    storage_clusters:
      lang === 'zh-Hans'
        ? require(`./lang/storage_clusters.zh`).default
        : require(`./lang/storage_clusters.en`).default,
    ecs_clusters:
      lang === 'zh-Hans'
        ? require(`./lang/ecs_clusters.zh`).default
        : require(`./lang/ecs_clusters.en`).default,
    maas:
      lang === 'zh-Hans'
        ? require(`./lang/maas.zh`).default
        : require(`./lang/maas.en`).default,
    nav: navigationNavForWebLang(lang),
  },
})

// Automatically generate the resources object
const resources = LanguagesSupported.reduce((acc: any, lang: string) => {
  acc[lang] = loadLangResources(lang)
  return acc
}, {})

i18n.use(initReactI18next).init({
  lng: undefined,
  fallbackLng: 'en-US',
  resources,
})

export const changeLanguage = i18n.changeLanguage
export default i18n
